export default __webpack_public_path__ + "static/985-6f5c79d64da91eb259bdcb91829b8c73.gif";